module.exports = __webpack_public_path__ + "static/fullsix.5d1225a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Sponsors/logos/fullsix.svg
// module id = 722
// module chunks = 213534597649335